const config = {
    // basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
    // like '/berry-material-react/react/default'
    basename: '/',
    defaultPath: '/dashboard/default',
    fontFamily: `'Roboto', sans-serif`,
    borderRadius: 12,
    // CMS Self Signup: overridable Selfregister base path (defaults inside the module when unset)
    cmsSelfregisterBasePath: process.env.REACT_APP_CMS_SELFREGISTER_BASE_PATH || undefined
};

export default config;
